import { render, staticRenderFns } from "./TopList.vue?vue&type=template&id=e45a0eb4&"
import script from "./TopList.vue?vue&type=script&lang=ts&"
export * from "./TopList.vue?vue&type=script&lang=ts&"
import style0 from "./TopList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports